import FilterButtonsOnState from '../State/FilterButtonsOnState';
import ApplyButtonRule from '../Rules/ApplyButtonRule';
import MapButtons from './MapButtons';

const GetVisibleButtons = (buttons, selection, state, filterValues, batchStatus) => {

    let allButtons = [];
    let newButtons = [];

    for (const button of buttons) {
            let tempButton = {...button};
            let childButtons = false
            if (button.Buttons !== undefined && Array.isArray(button.Buttons)) {
                childButtons = true
                tempButton.Buttons = [];
                for (const btn of button.Buttons) {
                    if ( ApplyButtonRule(btn, filterValues) ) {
                        tempButton.Buttons.push(btn);
                        childButtons = false;
                    }
                }
            }

            if ( ! childButtons && ApplyButtonRule(button, filterValues) ) {
                allButtons.push(tempButton);
            }
    }    

    for (const button of allButtons) {
        const useButton = ((selection && button.OnSelect) || (batchStatus && button.OnBatch)) || (! button.OnSelect && ! button.OnBatch)
        if (useButton) {
            let tempButton = {...button};
            if (button.Buttons !== undefined && Array.isArray(button.Buttons)) {
                tempButton.Buttons = [];
                for (const btn of button.Buttons) {
                    const useSubButton = ((selection && btn.OnSelect) || (batchStatus && btn.OnBatch)) || (! btn.OnSelect && ! btn.OnBatch)
                    if (useSubButton) {
                        tempButton.Buttons.push(btn);
                    }
                }
            }
            newButtons.push(tempButton);
        }
    }

    newButtons = MapButtons(FilterButtonsOnState(newButtons, state));

    return newButtons;

}

const PutButtonsIntoPassiveMode = (buttons) => {
    buttons = buttons.filter(button => button.Key.toLowerCase() == "printpreview");
    const newButtons = MapButtons(buttons);
    return newButtons;
}

export default GetVisibleButtons;
export {PutButtonsIntoPassiveMode}

